import { render, staticRenderFns } from "./FormatEditNavigationContainer.vue?vue&type=template&id=484db6aa&scoped=true&"
import script from "./FormatEditNavigationContainer.vue?vue&type=script&lang=ts&"
export * from "./FormatEditNavigationContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatEditNavigationContainer.vue?vue&type=style&index=0&id=484db6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484db6aa",
  null
  
)

export default component.exports